import { SvgIcon } from '@mui/material'

// Types
import type { SvgIconProps } from '@mui/material'

const ClockIconAtom = (props: SvgIconProps) => (
	<SvgIcon {...props} viewBox="0 0 20 21">
		<path
			fill="currentColor"
			d="M10.0003 18.9801C5.41699 18.9801 1.66699 15.2301 1.66699 10.6468C1.66699 6.06348 5.41699 2.31348 10.0003 2.31348C14.5837 2.31348 18.3337 6.06348 18.3337 10.6468C18.3337 15.2301 14.5837 18.9801 10.0003 18.9801ZM10.0003 3.98014C6.33366 3.98014 3.33366 6.98014 3.33366 10.6468C3.33366 14.3135 6.33366 17.3135 10.0003 17.3135C13.667 17.3135 16.667 14.3135 16.667 10.6468C16.667 6.98014 13.667 3.98014 10.0003 3.98014Z"
		/>

		<path
			fill="currentColor"
			d="M14.0837 11.4795H10.0003C9.50033 11.4795 9.16699 11.1462 9.16699 10.6462V6.56283C9.16699 6.06283 9.50033 5.72949 10.0003 5.72949C10.5003 5.72949 10.8337 6.06283 10.8337 6.56283V9.81283H14.0837C14.5837 9.81283 14.917 10.1462 14.917 10.6462C14.917 11.1462 14.5837 11.4795 14.0837 11.4795Z"
		/>
	</SvgIcon>
)

export default ClockIconAtom
